import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs';

import { QueryBuilderConfigProvider } from '@common/filter/query-builder-config-provider';
import { AdminDiaryEventFilterFieldProvider } from '@diary/filter/admin-diary-event-filter-field-provider';
import { addFilterFieldsToAdminForm, getDefaultWidgetConfigAdminForm } from '@feature/widget-admin/services/widget-admin-form';
import { WidgetConfiguration, WidgetConfigurationsService } from '@feature/widget-configs';
import { WidgetAdminHandler } from '@widget-admin/services/widget-admin-handler';
import { FormDefinition, FormFieldDefinition  } from '@feature/_app_modules/dynamic-forms/dynamic-form';
import { mapWherePropertiesMatch } from '@common/index';
import { DiaryConfiguration, SaveDiaryConfigurationRequest } from '@diary/models/diary-configuration';
import { DiaryEventsHttpService } from './diary-events-http-service';

@Injectable({
  providedIn: 'root'
})
export class DiaryWidgetAdminHandler implements WidgetAdminHandler {

  constructor(
    private readonly widgetConfigService: WidgetConfigurationsService,
    private readonly diaryEventsHttpService: DiaryEventsHttpService
  ) { }

  initialise(): boolean {
    return true;
  }

  getAdminForm(selectedConfig: WidgetConfiguration): FormDefinition | Observable<FormDefinition> {

    let formDefinition = getDefaultWidgetConfigAdminForm(selectedConfig);
    const getWidgetConfig = this.diaryEventsHttpService.getWidgetConfiguration(selectedConfig.id);


  return getWidgetConfig
      .pipe(map((config) => {

      const filterFieldProvider = new AdminDiaryEventFilterFieldProvider();
      const queryConfigProvider = new QueryBuilderConfigProvider(filterFieldProvider);
      const queryConfig = queryConfigProvider.getQueryBuilderConfig();

      formDefinition = addFilterFieldsToAdminForm(selectedConfig, queryConfig, formDefinition);

        formDefinition.fields.push(
                    {
                      key: 'includeNotices',
                      label: 'Display entries for Notice by Date',
                      value: { value: config.IncludeNotices},
                      type: 'dropdown',
                      dataKey: 'value',
                      optionLabel: 'label',
                      options: [
                        { label: 'Yes', value: true },
                        { label: 'No', value: false }
                      ]
                    } as FormFieldDefinition
                  );

      return formDefinition;

    }));

  }

  createCopyFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    return this.diaryEventsHttpService.copyWidgetConfiguration(this.createSaveRequest(selectedConfig, adminFormValue)).pipe(
      map(r => true)
    );

  }

  saveConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {

    return this.diaryEventsHttpService.saveWidgetConfiguration(this.createSaveRequest(selectedConfig, adminFormValue)).pipe(
      map(r => true)
    );

  }

  deleteConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);

    return this.widgetConfigService.delete(copyOfSelectedConfig).pipe(
      map(r => true)
    );

  }

  private createSaveRequest(selectedConfig: WidgetConfiguration, adminFormValue: any): SaveDiaryConfigurationRequest {
  
      const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);
  
      const saveRequest = {} as SaveDiaryConfigurationRequest;
  
      saveRequest.WidgetConfiguration = copyOfSelectedConfig;
      saveRequest.DiaryWidgetConfigurationModel = new DiaryConfiguration();
      saveRequest.DiaryWidgetConfigurationModel.IncludeNotices = adminFormValue.includeNotices?.value;
  
      return saveRequest;
    }

}
